// extracted by mini-css-extract-plugin
module.exports = {"input":"Rate_input__R74T6"};